import { Component, OnInit } from '@angular/core';

import { Organization } from '../models/organization';

import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-view-organizations',
  templateUrl: './view-organizations.component.html',
  styleUrls: ['./view-organizations.component.css']
})
export class ViewOrganizationsComponent implements OnInit {
  public organizations: Organization[] = [];
  public error: string;
  
  constructor(private globalService: GlobalService) {
    this.getOrganizations();
  }

  ngOnInit() {
    
  }

  getOrganizations() {
    this.globalService.getOrganizationsData()
        .subscribe(
            organizations => { this.organizations = organizations; } ,
            error => this.error = <any>error);
  }
}
